export default __webpack_public_path__ + "static/media/management-courses-new.ba5e1608.jpg";